module.exports = __webpack_public_path__ + "static/media/slider_active.3eb9c281.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider_active.svg
// module id = 39
// module chunks = 0